import forAdminOnly from '../../../common/hoc/for-admin-only';
import UpdateUrlsNotification from './update-urls-notification';

export default forAdminOnly(UpdateUrlsNotification);
